export default class SearchPlaceholder {
    constructor() {
        this.searchInput = document.querySelector('.wp-block-search__input');
        this.init();
    }

    init() {
        if (this.searchInput) {
            this.searchInput.setAttribute('placeholder', 'Search...');
        }
    }
}
